export const languages = {
    'pt-BR': { code: 'pt-BR', name: 'Português', flag: '🇧🇷', dir: 'ltr', short: 'pt' },
    'en-US': { code: 'en-US', name: 'English', flag: '🇺🇸', dir: 'ltr', short: 'en' },
    'es-ES': { code: 'es-ES', name: 'Español', flag: '🇪🇸', dir: 'ltr', short: 'es' },
    'fr-FR': { code: 'fr-FR', name: 'Français', flag: '🇫🇷', dir: 'ltr', short: 'fr' },
    'de-DE': { code: 'de-DE', name: 'Deutsch', flag: '🇩🇪', dir: 'ltr', short: 'de' },
    'it-IT': { code: 'it-IT', name: 'Italiano', flag: '🇮🇹', dir: 'ltr', short: 'it' },
    'ja-JP': { code: 'ja-JP', name: '日本語', flag: '🇯🇵', dir: 'ltr', short: 'ja' },
    'zh-CN': { code: 'zh-CN', name: '简体中文', flag: '🇨🇳', dir: 'ltr', short: 'zh' },
    'ko-KR': { code: 'ko-KR', name: '한국어', flag: '🇰🇷', dir: 'ltr', short: 'ko' }
} as const;

export type LanguageCode = keyof typeof languages;

export const defaultLanguage: LanguageCode = 'pt-BR';

const shortCodeMap: Record<string, LanguageCode> = {
    'pt': 'pt-BR',
    'en': 'en-US',
    'es': 'es-ES',
    'fr': 'fr-FR',
    'de': 'de-DE',
    'it': 'it-IT',
    'ja': 'ja-JP',
    'zh': 'zh-CN',
    'ko': 'ko-KR'
};

// Detecta o idioma do navegador
export function detectBrowserLanguage(): LanguageCode {
    if (typeof window === 'undefined') return defaultLanguage;

    const nav = navigator as Navigator & { userLanguage?: string };
    const browserLang = nav.language || nav.userLanguage || defaultLanguage;

    if (browserLang in languages) return browserLang as LanguageCode;

    const shortCode = browserLang.split('-')[0];
    if (shortCode in shortCodeMap) return shortCodeMap[shortCode];

    return defaultLanguage;
}

// Obtém o idioma da URL (ex: /en/, /es/)
export function getLanguageFromPath(): LanguageCode | null {
    if (typeof window === 'undefined') return null;

    const path = window.location.pathname;
    const langMatch = path.match(/^\/([a-z]{2})(?:\/|$)/);

    if (langMatch && langMatch[1] in shortCodeMap) {
        return shortCodeMap[langMatch[1]];
    }

    return null;
}

// Muda o idioma e redireciona
export function changeLanguage(newLang: LanguageCode) {
    const currentPath = window.location.pathname;
    const currentLangCode = getLanguageFromPath();
    const currentShort = currentLangCode ? languages[currentLangCode].short : null;
    const newShort = languages[newLang].short;

    let newPath: string;

    if (currentShort) {
        // Substitui o prefixo do idioma atual (com ou sem barra final)
        const prefixRegex = new RegExp(`^/${currentShort}(?:/|$)`);
        if (newLang === defaultLanguage) {
            newPath = currentPath.replace(prefixRegex, '/');
        } else {
            newPath = currentPath.replace(prefixRegex, `/${newShort}/`);
        }
    } else {
        // Adiciona o novo idioma
        if (newLang === defaultLanguage) {
            newPath = currentPath;
        } else {
            // Remove barra inicial se existir para evitar //
            const cleanPath = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;
            newPath = cleanPath.length > 0 ? `/${newShort}/${cleanPath}` : `/${newShort}/`;
        }
    }

    // Garante que não termine com //
    newPath = newPath.replace(/\/+/g, '/');

    window.location.href = newPath;
}
